module.exports = __webpack_public_path__ + "static/img/number_02@2x.e7dafbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/brandOperation/serviceContent/number_02@2x.png
// module id = Jn2d
// module chunks = 0